module.exports = __webpack_public_path__ + "static/media/GetQuote.93229462.jpeg";